import React from 'react'
import './CheckoutProduct.css'
import {useStateValue} from "./StateProvider";


function CheckoutProduct({id,image,title,price,rating}) {
const [{basket}, dispatch]=useStateValue();

    const RemovetoBasket =()=>{
        dispatch({
            type: 'Remove_From_Basket',
            id:id,

        })

    }
    return (
        <div className="checkoutProduct">
            {id}
            <img className="checkoutProduct_image" src={image}/>
            <div className= "checkoutProduct_info">
                <p className="checkoutProduct_title">{title}</p>
                <p className="checkoutProduct_price"><small>$</small><strong>{price}</strong></p>
            <div className="checkoutProduct_rating">
                 {Array(rating).fill()
                    .map((_, i)=>(<p>⭐</p>))}
            </div>
            <button onClick={RemovetoBasket}>Remove From Basket</button>

            </div>
            
        </div>
    )
}

export default CheckoutProduct
